export function formatEnumValue(value: string) {
  return value
    .split('_')
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
    .join(' ')
    .replace('Covid19', 'COVID-19')
    .replace(' Or ', '/')
    .replace(' - ', '-')
    .replace('Teap', 'TEAP');
}
